import { render, staticRenderFns } from "./aracBasvur.vue?vue&type=template&id=1c4c1ba8"
import script from "./aracBasvur.vue?vue&type=script&lang=js"
export * from "./aracBasvur.vue?vue&type=script&lang=js"
import style0 from "./aracBasvur.vue?vue&type=style&index=0&id=1c4c1ba8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports